<template>
  <div class="account-exception-container">
    <div v-if="loading" class="mask">
      <div style="text-align: center;">
        <el-progress type="circle" :percentage="percentage" text-color="white" />
        <h2 style="color: #FFFFFF;text-align: center;">删除中...</h2>
        <h3 style="color: #FFFFFF;text-align: center;">
          删除数 {{ total|numberFormat }} 条，已用时 {{ (interval_ms / 1000)|numberFormat(2) }} s
        </h3>
      </div>
    </div>
    <el-tabs v-model="search.error_type" type="card" @tab-click="handleSearch">
      <el-tab-pane label="含税收入 > 0、应收款 < 0" name="1"/>
      <el-tab-pane label="20260210异常" name="2"/>
    </el-tabs>
    <el-form inline :model="search" size="mini">
      <el-form-item>
        <el-input v-model="search.order_no" placeholder="搜索订单编号"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <ml-table ref="table" :api="api" :search="search">
      <template slot="columns">
        <el-table-column type="selection" width="55"/>
        <el-table-column type="index"/>
        <el-table-column label="回款时间" prop="transfer_time"/>
        <el-table-column prop="amount" label="回款金额" :min-width="220">
          <template slot-scope="scope">
            {{ scope.row.amount|numberFormat(2) }}
          </template>
        </el-table-column>
        <el-table-column label="订单编号" :min-width="220">
          <template slot-scope="scope">
            <el-link :href="`/ad/${scope.row.order_id}/edit`" target="_blank">{{ scope.row.order_no }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="订单剩余应收款" :min-width="220">
          <template slot-scope="scope">
            {{ scope.row.remain_account|numberFormat(2) }}
          </template>
        </el-table-column>
        <el-table-column label="订单含税收入" :min-width="220">
          <template slot-scope="scope">
            {{ scope.row.payment_account|numberFormat(2) }}
          </template>
        </el-table-column>
        <el-table-column label="操作时间" prop="created_at" width="120"/>
      </template>
      <template slot="footer">
        <el-button v-permission="'account_exception_module_del'" type="primary" round size="mini" @click="handleDelete">批量删除</el-button>
      </template>
    </ml-table>
  </div>
</template>
<script>
import MlTable from "@/components/MlTable/index";
import {accountListException, delAccount} from "@/api/account";

export default {
  name: "AccountException",
  components: {MlTable},
  data() {
    return {
      api: accountListException,
      loading: false,
      interval_ms: 0,
      total: 0,
      percentage: 0,
      search: {
        error_type: '1',
      },
    }
  },
  methods: {
    handleSearch: function () {
      this.$refs.table.handleSearch()
    },
    handleDelete: async function () {
      const selection = this.$refs.table.interfaceGetSelection();
      this.total = selection.length
      if (this.total === 0) {
        return this.$message({type: 'warning', message: '请选择要删除的回款记录！'});
      }

      this.showModal({
        h: this,
        text: `确认删除【${this.total}条】回款记录吗？`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          this.loading = true;
          const that = this
          for (let i = 0; i < this.total; i++) {
            const response = await delAccount({id: selection[i].id});
            if (!response.success) {
              that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
              return;
            }
            this.percentage = parseInt((i * 100 / this.total) + '')
          }
          this.loading = false;
          that.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
          that.handleSearch();
        }
      });
    }
  }
}
</script>
<style lang="scss">
.account-exception-container {
  padding: 20px;

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

